import { render, staticRenderFns } from "./AddMedicineItem.vue?vue&type=template&id=af59c3cc&scoped=true"
import script from "./AddMedicineItem.vue?vue&type=script&lang=js"
export * from "./AddMedicineItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af59c3cc",
  null
  
)

export default component.exports